export default __webpack_public_path__ + "static/media/usage-calculator.cac8b935.png";